import React from 'react'
import Config from "../../config/Configs";

const SupportInfo = () => {
    return (
        <div className="digital-download-view">
            <div><span>Visit:</span> <a href={Config.contactUrl} rel="noopener noreferrer" target="_blank">Digital Support</a></div>
            <div><span>Email:</span> mydigital@matildaed.com.au</div>
            <div><span>Phone:</span> 1300 277 235</div>
        </div>
    )
}

export default SupportInfo
